import {
  AccountSectionEnum,
  AccountSectionEnumEn,
} from "~/types/account/account.types";

const accountSections: AccountSectionEnum[] = [
  AccountSectionEnum.PROGRAMMATION,
  AccountSectionEnum.AGENDA,
  AccountSectionEnum.MEMBERSHIP,
  AccountSectionEnum.SPONSORSHIP,
  AccountSectionEnum.BIRTHDAY,
];

const accountSectionsEn: AccountSectionEnumEn[] = [
  AccountSectionEnumEn.PROGRAMMATION,
  AccountSectionEnumEn.AGENDA,
  AccountSectionEnumEn.MEMBERSHIP,
  AccountSectionEnumEn.SPONSORSHIP,
  AccountSectionEnumEn.BIRTHDAY,
];

export const getAccountSectionsByLanguage = (language: string) => {
  return language === "Fr" ? accountSections : accountSectionsEn;
};
